var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('strong',[_vm._v("Note")]),_vm._v(": Devices running macOS 11.0+ (Big Sur) must be enrolled in JumpCloud MDM to be managed by JumpCloud’s Mac "+_vm._s(_vm.componentData)+". ")])
}
var staticRenderFns = []

export { render, staticRenderFns }